// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColorPickerWithActions {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 75%;
  z-index: 100;
  background-color: var(--base_color2);
  border: 1px solid var(--gray_light1);
  border-radius: 6px;
  box-shadow: var(--shadow_light);
}
.ColorPickerWithActions .ColorPickerWithActions-picker-wrapper input {
  color: var(--base_color1);
}
.ColorPickerWithActions .ColorPickerWithActions-actions {
  display: flex;
  justify-content: flex-end;
  padding: 4px;
}
.ColorPickerWithActions .sketch-picker {
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ColorPickerWithActions/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,oCAAA;EACA,oCAAA;EACA,kBAAA;EACA,+BAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AAAJ;AAGE;EACE,2BAAA;AADJ","sourcesContent":[".ColorPickerWithActions {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 75%;\n  z-index: 100;\n  background-color: var(--base_color2);\n  border: 1px solid var(--gray_light1);\n  border-radius: 6px;\n  box-shadow: var(--shadow_light);\n\n  .ColorPickerWithActions-picker-wrapper input {\n    color: var(--base_color1);\n  }\n\n  .ColorPickerWithActions-actions {\n    display: flex;\n    justify-content: flex-end;\n    padding: 4px;\n  }\n\n  .sketch-picker {\n    box-shadow: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
